<template >
    <div>
    <el-table-column
    v-for="(c, i) in data.children||[]"
    :label="c.title"
    :width="c.width"
    :prop='c.key'
    :align='c.align'
    >
        <template slot-scope="scope2" >
          <expand
            v-if="c.render"
            :render="c.render"
            :row="scope2.row"
            :index="i"
            :column="c"
            >
            </expand>
            <span v-else>{{scope2.row[c.key]}}</span>
        </template>
        <!-- <childrenD :data='c' /> -->
    </el-table-column>
    </div>
</template>

<script>
import expand from './expand.vue'
export default {
  name: 'childrenD',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    expand
  },
  created() {
  },
  methods: {
    
  }
}
</script>
